'use client'

import { sessionStorageKey } from '@/constants/sessionstorage-key'
import { ArtistType } from '@/types/artist.type'

export const ARTIST_LIST = ['hosoo', 'loopy', 'saryeonghwa']

export function getArtistPathName(): ArtistType {
  if (typeof window === 'undefined') {
    return ''
  }

  const pathname = location.pathname.split('/')[1]

  if (!ARTIST_LIST.includes(pathname)) {
    return ''
  }

  return pathname as ArtistType
}

export function getArtistLastPage(): ArtistType {
  if (typeof window === 'undefined') {
    return ''
  }

  const artist = (sessionStorage.getItem(sessionStorageKey.lastPageArtistFristPathname) as ArtistType) || ''

  if (!ARTIST_LIST.includes(artist)) {
    return ''
  }

  return artist as ArtistType
}
